/** True when the browser is on a public auth route (no session required). */
const PUBLIC_AUTH_PATHS = new Set([
	'/login',
	'/forgot-password',
	'/reset-password',
	'/verify-email',
	'/sso/callback',
])

export function isPublicAuthPage(): boolean {
	const path = window.location.pathname.replace(/\/+$/, '').toLowerCase() || '/'
	return PUBLIC_AUTH_PATHS.has(path)
}
